function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect } from "react";
import classnames from "classnames";
import MondayAiIcon from "components/core/monday-ai-icon/monday-ai-icon-component";
import { StyledAiExpandableBundle } from "./ai-expandable-bundle-component.scss";
const ChevronDownIcon = ()=>/*#__PURE__*/ _jsx("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "currentColor",
        children: /*#__PURE__*/ _jsx("path", {
            d: "M8 10.5a.5.5 0 01-.354-.146l-4-4a.5.5 0 11.708-.708L8 9.293l3.646-3.647a.5.5 0 11.708.708l-4 4A.5.5 0 018 10.5z"
        })
    });
const AiExpandableBundle = ({ title, heading, subtitle, description, productLogos = [], defaultExpanded = false, collapsible = true })=>{
    const [isExpanded, setIsExpanded] = useState(defaultExpanded || !collapsible);
    const [isFullyExpanded, setIsFullyExpanded] = useState(defaultExpanded || !collapsible);
    useEffect(()=>{
        if (!collapsible) setIsExpanded(true);
    }, [
        collapsible
    ]);
    useEffect(()=>{
        if (isExpanded) {
            const timer = setTimeout(()=>setIsFullyExpanded(true), 300);
            return ()=>clearTimeout(timer);
        }
        setIsFullyExpanded(false);
    }, [
        isExpanded
    ]);
    return /*#__PURE__*/ _jsxs(StyledAiExpandableBundle, {
        className: classnames({
            expanded: isExpanded
        }),
        children: [
            /*#__PURE__*/ _jsxs("div", _object_spread_props(_object_spread({
                className: "bundle-header"
            }, collapsible && {
                "aria-expanded": isExpanded,
                onClick: ()=>setIsExpanded((prev)=>!prev)
            }), {
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: "bundle-header-left",
                        children: [
                            /*#__PURE__*/ _jsx(MondayAiIcon, {
                                size: 20
                            }),
                            /*#__PURE__*/ _jsx("span", {
                                className: "bundle-header-title",
                                children: title
                            })
                        ]
                    }),
                    collapsible && /*#__PURE__*/ _jsx("div", {
                        className: classnames("bundle-chevron", {
                            "chevron-expanded": isExpanded
                        }),
                        children: /*#__PURE__*/ _jsx(ChevronDownIcon, {})
                    })
                ]
            })),
            /*#__PURE__*/ _jsx("div", {
                className: classnames("bundle-content-wrapper", {
                    "content-expanded": isExpanded
                }),
                children: /*#__PURE__*/ _jsx("div", {
                    className: classnames("bundle-content-overflow", {
                        "fully-expanded": isFullyExpanded
                    }),
                    children: /*#__PURE__*/ _jsx("div", {
                        className: "bundle-content",
                        children: /*#__PURE__*/ _jsxs("div", {
                            className: "bundle-content-inner",
                            children: [
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "bundle-text-section",
                                    children: [
                                        /*#__PURE__*/ _jsx("h2", {
                                            className: "bundle-heading",
                                            children: heading
                                        }),
                                        /*#__PURE__*/ _jsx("span", {
                                            className: "bundle-subtitle",
                                            children: subtitle
                                        }),
                                        /*#__PURE__*/ _jsx("span", {
                                            className: "bundle-description",
                                            children: description
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "bundle-product-logos",
                                    children: productLogos.map((logo, index)=>/*#__PURE__*/ _jsxs("span", {
                                            className: "bundle-product-logo-icon",
                                            children: [
                                                /*#__PURE__*/ _jsx("img", {
                                                    src: logo.src,
                                                    alt: logo.alt
                                                }),
                                                logo.tooltip && /*#__PURE__*/ _jsx("div", {
                                                    className: "bundle-tooltip",
                                                    children: logo.tooltip
                                                })
                                            ]
                                        }, `${logo.src}-${index}`))
                                })
                            ]
                        })
                    })
                })
            })
        ]
    });
};
export default AiExpandableBundle;
